import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createTrapScoreLink } from "../../../common/helpers/helpers";
import { getRefGenome } from "../../../state/selectors/general.selectors";

const TrapScoreLink = ({
  showExternalIconLink,
  cssClasses,
  trapQuery,
  genomeName,
}) => {
  const url = createTrapScoreLink(trapQuery, genomeName);
  if (!url) return null;
  return (
    <a
      data-testid="TrapScoreLink-component"
      href={url}
      target="_blank"
      className={cssClasses}
    >
      {showExternalIconLink && (
        <i
          data-testid="TrapScoreLink-icon"
          className="fa fa-external-link mr-1"
        />
      )}
      TraP Score
    </a>
  );
};

TrapScoreLink.propTypes = {
  showExternalIconLink: PropTypes.bool,
  cssClasses: PropTypes.string,
  genomeName: PropTypes.string,
  trapQuery: PropTypes.string,
};

TrapScoreLink.defaultProps = {
  showExternalIconLink: false,
  cssClasses: "",
  genomeName: "",
  trapQuery: "",
};

const mapStateToProps = (state) => ({
  genomeName: getRefGenome(state),
});

export default connect(mapStateToProps, {})(TrapScoreLink);
